/**
 * AI对话框展示热搜的组件
 * zxw
 * 2024-05-13
 */

import React, { useState } from 'react';
import { 
    DownOutlined,
    UpOutlined,
    UpSquareFilled,
 } from '@ant-design/icons';
 import { Row, Col } from 'antd';

const AssistantBoxHot = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isHover, setIsHover] = useState(false);
    return (
        <div style={{ padding: '15px 15px 0 15px'}}>
            <div style={{
                cursor: 'pointer',
                padding: '10px 10px',
                backgroundColor: isHover?'#F3F5FD':'#F8F8FA',
                borderRadius: 5,
                width: 'auto',
                display: 'inline-block',
            }} 
                onMouseEnter={()=>{setIsHover(true)}}
                onMouseLeave={()=>{setIsHover(false)}}
                onClick={()=>{setIsOpen(!isOpen)}}>找到了&nbsp;{props.networkDataList.length}&nbsp;条热榜作为参考：<span style={{marginLeft: 10 }}>{isOpen?<UpOutlined style={{ fontSize: 12 }} />:<DownOutlined style={{ fontSize: 12 }} />}</span></div>
            {
                isOpen?<div style={{
                    padding: '12px 10px',
                    backgroundColor: '#F8F8FA',
                    borderRadius: 5,
                    marginTop: 10,
                }}>
                    <span>已为您在互联网搜索到如下相关的资料：</span>
                    <div>
                        {
                            props.networkDataList.map((item, index)=>{
                                return <Row key={index} style={{ height: 25, marginTop: 3, marginBottom: 3 }}>
                                    <Col span={1}><span style={{ 
                                            fontSize: item.number&&parseInt(item.number)<4?15:12,
                                            color: item.number&&parseInt(item.number)<4?'#F26D5F':'#FF904D',
                                            fontWeight: item.number&&parseInt(item.number)<4?600:400,
                                        }}>{!item.number&&index===0?<UpSquareFilled style={{ color: '#F26D5F', fontSize: 15 }} />:item.number}</span></Col>
                                    <Col span={19}><div key={index} style={{
                                            whiteSpace: 'nowrap',       /* 确保文本在一行内显示 */
                                            overflow: 'hidden',         /* 超出部分隐藏 */
                                            textOverflow: 'ellipsis'    /* 使用省略号表示被截断的文本 */
                                        }}>
                                            <a href={item.link} target="_blank" rel="noopener noreferrer">{item.title}</a><span style={{ marginLeft: 10,fontSize: 12,color: '#A5A5A5'}}>{item.hot_rate}</span>
                                        </div>
                                    </Col>
                                    <Col span={4}>
                                        {
                                            item.hot_tags?<span style={{ fontSize: 12,color: '#fff',backgroundColor: item.hot_tags in ['沸','首发','辟谣','首发','独家']?'#F26D5F':item.hot_tags==='新'?'#FF3852':'#FF904D',padding: '1px 3px',borderRadius: 3 }}>{item.hot_tags}</span>:''
                                        }
                                    </Col>
                                </Row>
                                return 
                            })
                        }
                    </div>
                </div>:''
            }
        </div>
    );
}

export default AssistantBoxHot;